export const PADDING = 24;
